import React from "react";
import { IMAGES } from "../data/content";
import { OptImg } from "@/components/OptImg";

export function AwardBadge({ className = "", iconClass = "h-28", caption }) {
  return (
    <div className={`flex flex-col items-start gap-3 ${className}`} data-testid="award-badge">
      <OptImg sizes="200px" loading="lazy" src={IMAGES.awardBadge} alt="Stora Talarpriset award badge, Swedish national speaker award, Maurice Jenkens nominated 2024 and 2025" className={`${iconClass} w-auto`} />
      <p className="text-white/80 text-sm leading-snug">
        {caption ? caption : (<>Twice nominated for my work on<br />psychological safety and trust.</>)}
      </p>
    </div>
  );
}
